import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useGetAuftragMutation, useNeuerAuftragMutation } from "../../api/AuftragAPI";
import MapComponent, { ILocation } from "../../component/MapComponent/MapComponent";
import UploadContainer from "../../component/UploadContainer";
import { upload } from "../../services/All";
import { setModalMessageOkDialogVisible } from '../../Slice/DialogSlice';
import { AppDispatch } from '../../Store';
import { IAuftraggeber, IAuftragRequest, IProfileDto, ProfileInfo } from '../../types/Types';
import Footer from '../footer/Footer';
import LandingpageHeader from '../header/LandingpageHeader';
import styles from './neuerauftrag.module.scss';
import { useWhoamiMutation } from '../../api/LoginAPI';
import { useGetAuftraggeberListeMutation, useGetVerkaeuferListeMutation } from '../../api/OfficeAPI';
import { LoadingModal } from '../../component/LoadingModal/LoadingModal';
import MaxInputAnzahlComponent from '../../component/MaxInputAnzahlComponent';
import AnleitungDownloadButtonComponent from '../../component/buttons/AnleitungDownloadButtonComponent';
import HinweisMessverfahrenDownloadButtonComponent from '../../component/buttons/HinweisMessverfahrenDownloadButtonComponent';
import HinweisMaterialienDownloadButtonComponent from '../../component/buttons/HinweisMaterialienDownloadButtonComponent';

export const emptyAuftrag: IAuftragRequest = {
  uid: '',
  art: '',
  vorname_endkunde: '',
  name_endkunde: '',
  strasse_lieferadresse: '',
  hausnummer_lieferadresse: '',
  postleitzahl_lieferadresse: '',
  stadt_lieferadresse: '',
  land_lieferadresse: '',
  spaetmesstermin: null,
  telefon_lieferadresse: '',
  besonderheiten: '',
  messzeitpunkt: '',
  email_lieferadresse: '',
  mobil1_lieferadresse: '',
  mobil2_lieferadresse: '',
  ansprechpartner: '',
  kontakt_ansprechpartner: '',
  email_ansprechpartner: '',
  auftragsnr_ag: '',
  lat: 0,
  lng: 0,
  auftraggeberUid: '',
  lieferungKw: 0,
  lieferungJahr: 0,
  lieferungLieferant: '',
}

const libraries: ("places")[] = ["places"];

type IErrorType = {
  art?: string,
  auftragsnr_ag?: string,
  name_endkunde?: string,
  vorname_endkunde?: string,
  adresse?: string,
  adresseBesonderheit?: string,
  telefon_lieferadresse?: string,
}

/**
 * @author noone
 */
export default function NeuerAuftrag() {

  const location = useLocation();
  const state = location.state as { uid?: string; action?: string } | null;

  const action = state?.action;
  const uid = state?.uid;

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  const [neuerAuftragAPI] = useNeuerAuftragMutation();
  const [getAuftragAPI] = useGetAuftragMutation();
  const [whoamiAPI] = useWhoamiMutation();
  const [getAuftraggeberListeAPI] = useGetAuftraggeberListeMutation();
  const [getVerkaeuferListeAPI] = useGetVerkaeuferListeMutation();

  const [auftragRequest, setAuftragRequest] = useState<IAuftragRequest>(emptyAuftrag);
  const [spaetmesstermin, setSpaetmesstermin] = useState<string>(""); // ist nicht schön, ich weiss
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [whoami, setWhoami] = useState<ProfileInfo>();
  const [errors, setErrors] = useState<IErrorType>({});
  const [moeglicheAuftraggeber, setMoeglicheAuftraggeber] = useState<IAuftraggeber[]>([]);
  const [moeglicheVerkaeufer, setMoeglicheVerkaeufer] = useState<{ uid: string, name: string }[]>([]);

  const [messzeitpunkt1, setMesszeitpunkt1] = useState<string>("");
  const [messzeitpunkt2, setMesszeitpunkt2] = useState<string>("");

  const [checkboxAdresseBesonderheiten, setCheckboxAdresseBesonderheiten] = useState<boolean>(false);

  const validate = () => {
    const newErrors: IErrorType = {};

    /*
    if (!auftragRequest.auftragsnr_ag || auftragRequest.auftragsnr_ag === "") {
      newErrors.auftragsnr_ag = "Eigene Auftragsnummer darf nicht leer sein.";
    }

    if (!auftragRequest.vorname_endkunde || auftragRequest.vorname_endkunde === "") {
      newErrors.vorname_endkunde = "Vorname des Endkunden darf nicht leer sein.";
    }

    if (!auftragRequest.name_endkunde || auftragRequest.name_endkunde === "") {
      newErrors.name_endkunde = "Name des Endkunden darf nicht leer sein.";
    }

    if (!auftragRequest.art || auftragRequest.art === "") {
      newErrors.art = "Auftragsart darf nicht leer sein.";
    }

    if (!auftragRequest.stadt_lieferadresse || auftragRequest.stadt_lieferadresse === "") {
      newErrors.adresse = "Stadt der Lieferadresse darf nicht leer sein.";
    }

    if (
      (!auftragRequest.telefon_lieferadresse || auftragRequest.telefon_lieferadresse === "")
      && (!auftragRequest.mobil1_lieferadresse || auftragRequest.mobil1_lieferadresse === "")
      && (!auftragRequest.mobil2_lieferadresse || auftragRequest.mobil2_lieferadresse === "")
      && (!auftragRequest.email || auftragRequest.email === "")
    ) {
      newErrors.telefon_lieferadresse = "Mindestens eine Telefon, Mobilfunknummer oder E-Mailadresse muss angegeben werden.";
    }
    */

    if (auftragRequest.stadt_lieferadresse === "" && checkboxAdresseBesonderheiten === false) {
      newErrors.adresseBesonderheit = "Lieferadresse darf nicht leer sein oder Haken muss aktiviert werden.";
      //console.log("ss", "" + checkboxAdresseBesonderheiten);
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length !== 0) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
    return Object.keys(newErrors).length === 0; // true, wenn keine Fehler
  };

  useEffect(() => {
    setAuftragRequest((prevData) => ({
      ...prevData,
      messzeitpunkt: messzeitpunkt1 + (messzeitpunkt1 ? "_" : "") + messzeitpunkt2
    }));

    if (messzeitpunkt2 !== "eilig") {
      setSpaetmesstermin("");
    }
  }, [messzeitpunkt2]);

  const arten = [
    { art: 'Küche', text: 'Küche' },
    { art: 'Küchenumbau', text: 'Küchenumbau' },
    { art: 'HWR', text: 'HWR' },
    { art: 'APL', text: 'APL' },
    { art: 'Sonstiges', text: 'Sonstiges' },
  ]

  /*const noEnterKey = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  };*/

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAuftragRequest((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));

    if (e.target.name === "spaetmesstermin") {
      setSpaetmesstermin(e.target.value);
    }
  }

  const handleChangeLieferungKw = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (/^\d{0,2}$/.test(e.target.value)) {
      setAuftragRequest((prevData) => ({
        ...prevData,
        [e.target.name]: e.target.value
      }));
    }
  }

  const handleChangeLieferungJahr = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (/^\d{0,4}$/.test(e.target.value)) {

      setAuftragRequest((prevData) => ({
        ...prevData,
        [e.target.name]: e.target.value
      }));
    }
  }

  const handleChangeTextarea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setAuftragRequest((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value
    }));
  }

  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (e.target.name === "art") {
      setAuftragRequest((prev) => ({ ...prev, art: e.target.value }));
    } else if (e.target.name === "auftraggeberUid") {
      setAuftragRequest((prev) => ({ ...prev, auftraggeberUid: e.target.value }));
    } else if (e.target.name === "verkaeuferUid") {
      setAuftragRequest((prev) => ({ ...prev, verkaeuferUid: e.target.value }));
    }
  }

  const speichern = (e: { preventDefault: () => void; target: any; }) => {
    e.preventDefault();

    setIsLoading(true);

    // Validieren
    if (!validate()) {
      setIsLoading(false);
      return;
    }

    // Auftrag senden
    neuerAuftragAPI(auftragRequest)
      .unwrap().then(auftrag => {

        // Fotos hochladen
        uploadedFiles.map((file) =>
          upload(auftrag.uid, file));
        return auftrag;
      })
      .then((auftrag) => {

        //
        dispatch(setModalMessageOkDialogVisible({
          visible: true,
          text: 'Erfolgreich gespeichert!'
        }));

        // Weiter
        navigate("/eigeneauftraege/detail/" + auftrag.uid);

      })
      .catch((error) => console.log(error))
      .finally(() => {
        setIsLoading(false);
      });

  }

  const handleFilesChange = (files: File[]) => {
    setUploadedFiles(files);
  };

  const locationset = (location: ILocation) => {
    console.log("locationset!! ", location);
    //console.log("address_components", location.place?.address_components);
    setAuftragRequest((prevData) => ({
      ...prevData,
      strasse_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'route')?.long_name || '',
      hausnummer_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'street_number')?.long_name || '',
      postleitzahl_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'postal_code')?.long_name || '',
      stadt_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'locality')?.long_name || '',
      land_lieferadresse: location.place?.address_components?.find(item => item.types[0] === 'country')?.long_name || '',
      lat: location.lat,
      lng: location.lng,
    }));
    //console.log(auftragRequest);
  };

  const setWith100PercentForInputMapField = () => {
    const interval = setInterval(() => {
      // finde das Element mit Klasse "autocomplete-control"
      const autocompleteControl = document.querySelector(".autocomplete-control");
      if (autocompleteControl && autocompleteControl.parentElement) {
        // setze style am Eltern-Element
        autocompleteControl.parentElement.style.width = "100%";
        autocompleteControl.parentElement.style.left = "0px";
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }

  useEffect(() => {
    console.log("zeitpunkt: ", messzeitpunkt1, messzeitpunkt2);
  }, [messzeitpunkt1, messzeitpunkt2]);

  useEffect(() => {
    if (action === 'copy' && uid) {
      setIsLoading(true);
      getAuftragAPI(uid).unwrap()
        .then((data) => {
          const parts = data.messzeitpunkt.split('_');
          setMesszeitpunkt1(parts[0] || "");
          setMesszeitpunkt2(parts[1] || "");

          setAuftragRequest({
            uid: '',
            art: data.art,
            auftragsnr_ag: data.auftragsnr_ag,
            besonderheiten: data.besonderheiten,
            messzeitpunkt: data.messzeitpunkt,
            spaetmesstermin: data.spaetmesstermin,
            vorname_endkunde: data.vorname_endkunde,
            name_endkunde: data.name_endkunde,
            strasse_lieferadresse: data.strasse_lieferadresse,
            hausnummer_lieferadresse: data.hausnummer_lieferadresse,
            postleitzahl_lieferadresse: data.postleitzahl_lieferadresse,
            stadt_lieferadresse: data.stadt_lieferadresse,
            land_lieferadresse: data.land_lieferadresse,
            telefon_lieferadresse: data.telefon_lieferadresse,
            mobil1_lieferadresse: data.mobil1_lieferadresse,
            mobil2_lieferadresse: data.mobil2_lieferadresse,
            email_lieferadresse: data.email_lieferadresse,
            lng: data.lng,
            lat: data.lat,
            ansprechpartner: data.name_ansprechpartner,
            kontakt_ansprechpartner: data.kontakt_ansprechpartner,
            email_ansprechpartner: data.email_ansprechpartner,
            auftraggeberUid: undefined,
            lieferungJahr: undefined,
            lieferungKw: undefined,
            lieferungLieferant: undefined
          });
        })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false))
        ;
    }
  }, [action, uid]);

  useEffect(() => {
    whoamiAPI().unwrap()
      .then(data => setWhoami(data))
      .catch((e) => console.log(e));
  }, [whoamiAPI]);

  useEffect(() => {
    if (whoami?.rollen.includes("office")) {
      getAuftraggeberListeAPI().unwrap()
        .then(setMoeglicheAuftraggeber)
        .catch((error) => console.log(error))
    }
  }, [whoami]);

  useEffect(() => {
    if (auftragRequest.auftraggeberUid) {
      getVerkaeuferListeAPI(auftragRequest.auftraggeberUid).unwrap()
        .then((data) => {
          setMoeglicheVerkaeufer(data);
        })
        .catch((error) => console.log(error))
    }
  }, [auftragRequest.auftraggeberUid]);

  useEffect(() => {
    setWith100PercentForInputMapField();
  }, []);

  return (
    <div className={classNames(styles.centerContainer)}>

      <LandingpageHeader />

      <LoadingModal show={isLoading} />

      <div className="container">

        <button
          onClick={() => {
            navigate({
              pathname: "/",
              search: ""
            });
          }}

          style={{ marginBottom: "20px" }}
          className=' btn btn-outline-primary'
        >
          <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
        </button>

        <h3>{(state?.action === 'copy') ? t('deTranslation.neuerAuftrag.titelCopy') : t('deTranslation.neuerAuftrag.titelNeu')}</h3>

        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 3fr)) " , textAlign: "right", margin: "20px 20px", }}>

          <div><HinweisMessverfahrenDownloadButtonComponent /></div>

          <div><HinweisMaterialienDownloadButtonComponent /></div>

          <div><AnleitungDownloadButtonComponent /></div>
        </div>

        <form onSubmit={speichern}>

          {moeglicheAuftraggeber && moeglicheAuftraggeber.length > 0 &&
            <>
              <div className="form-group">
                Auftraggeber: <select className='form-control' name="auftraggeberUid" value={auftragRequest.auftraggeberUid || ""} onChange={handleChangeSelect} >
                  <option value="">-- Bitte auswählen --</option>
                  {moeglicheAuftraggeber.map((e) =>
                    <option key={e.uid} value={e.uid}>{e.name}</option>
                  )}
                </select>
              </div>

              {auftragRequest.auftraggeberUid &&
                <>
                  <div className="form-group">
                    Verkäufer:
                    <select className='form-control' name="verkaeuferUid" value={auftragRequest.verkaeuferUid || ""} onChange={handleChangeSelect} >
                      <option value="">-- Bitte auswählen --</option>
                      {moeglicheVerkaeufer.map((e) =>
                        <option key={e.uid} value={e.uid}>{e.name}</option>
                      )}
                    </select>
                  </div>
                </>
              }

            </>
          }

          <div className="form-group">
            Art: <select required={true} className='form-control' name="art" value={auftragRequest.art || ""} onChange={handleChangeSelect} >
              <option value="">-- Bitte auswählen --</option>
              {arten.map((e) =>
                <option key={e.art} value={e.art}>{e.text}</option>
              )}

            </select>
            {errors.art && <p className="text-red-500">{errors.art}</p>}
          </div>

          <div className="form-group">
            Eigene Auftragsnummer:
            <input required={true} className='form-control' name="auftragsnr_ag" value={auftragRequest?.auftragsnr_ag} onChange={handleChange} maxLength={255} />
            {errors.art && <p className="text-red-500">{errors.auftragsnr_ag}</p>}
          </div>

          <div className="form-group">
            Messzeitpunkt:

            <select value={messzeitpunkt1} className='form-control' name='messzeitpunkt1' style={{ width: "auto", display: "inline" }} onChange={(e) => { e.preventDefault(); setMesszeitpunkt1(e.target.value); setMesszeitpunkt2("0"); }}>
              <option value="">-- Bitte auswählen --</option>
              <option value="1">Neubau</option>
              <option value="2">Sanierung</option>
              <option value="3">Bestand</option>
            </select>

            {messzeitpunkt1 === "1" &&
              <>
                <i className="bi bi-arrow-right"></i>
                <select value={messzeitpunkt2} className='form-control' style={{ width: "auto", display: "inline" }} name='messzeitpunkt2' onChange={(e) => { e.preventDefault(); setMesszeitpunkt2(e.target.value); }}>
                  <option value="">-- Bitte auswählen --</option>
                  <option value="sofort">Sofort</option>
                  <option value="nach_putz">Nach Putz</option>
                  <option value="nach_estrich">Nach Estrich</option>
                  <option value="eilig">Eilig (Unterlagen zurück bis zum)</option>
                </select>
              </>
            }

            {messzeitpunkt1 === "2" &&
              <>
                <i className="bi bi-arrow-right"></i>
                <select className='form-control' style={{ width: "auto", display: "inline" }} name='messzeitpunkt2' onChange={(e) => { e.preventDefault(); setMesszeitpunkt2(e.target.value); }}>
                  <option value="">-- Bitte auswählen --</option>
                  <option value="sofort">Sofort</option>
                  <option value="nach_putz">Nach Putz</option>
                  <option value="nach_estrich">Nach Estrich</option>
                  <option value="eilig">Eilig (Unterlagen zurück bis zum)</option>
                </select>
              </>
            }

            {messzeitpunkt1 === "3" &&
              <>
                <i className="bi bi-arrow-right"></i>
                <select className='form-control' style={{ width: "auto", display: "inline" }} name='messzeitpunkt2' onChange={(e) => { e.preventDefault(); setMesszeitpunkt2(e.target.value); }}>
                  <option value="">-- Bitte auswählen --</option>
                  <option value="sofort">Sofort</option>
                  <option value="eilig">Eilig (Unterlagen zurück bis zum)</option>
                </select>
              </>
            }

            {messzeitpunkt2 === "eilig" &&
              <>
                <i className="bi bi-arrow-right"></i>
                <input type="date" className='form-control' style={{ width: "auto", display: "inline" }} name="spaetmesstermin" value={spaetmesstermin} onChange={handleChange} />
              </>
            }

          </div>

          <div className="form-group">
            Vorname Endkunde*:
            <input required={true} className='form-control' name="vorname_endkunde" value={auftragRequest?.vorname_endkunde} onChange={handleChange} maxLength={100} />
            {errors.vorname_endkunde && <p className="text-red-500">{errors.vorname_endkunde}</p>}
          </div>

          <div className="form-group">
            Name Endkunde oder Firma*:
            <input required={true} className='form-control' name="name_endkunde" value={auftragRequest?.name_endkunde} onChange={handleChange} maxLength={100} />
            {errors.name_endkunde && <p className="text-red-500">{errors.name_endkunde}</p>}
          </div>

          <div className="form-group">
            Lieferadresse:
          </div>

          <div style={{ height: '500px', width: '100%' }}>
            {errors.adresse && <p className="text-red-500">{errors.adresse}</p>}
            <MapComponent startLat={auftragRequest.lat !== 0 ? auftragRequest.lat : undefined} startLng={auftragRequest.lng !== 0 ? auftragRequest.lng : undefined} onLocationSet={locationset} scrollZoom={false} />
          </div>

          <div className="form-group">
            {errors.adresseBesonderheit && <p className="text-red-500">{errors.adresseBesonderheit}</p>}
            <input type="checkbox" checked={checkboxAdresseBesonderheiten} onChange={(e) => setCheckboxAdresseBesonderheiten(e.target.checked)} /> Der Ort konnte nicht auf der Karte gefunden werden, ich werde die Adresse bei Hinweise zum Aufmaß und Messzeitpunkt weiter unten eingeben.
          </div>

          {/*}
          <div className="card" style={{ padding: "20px", marginBottom: "30px" }}>
            Lieferadresse:
            <p></p>
            <br />{auftragRequest.vorname_endkunde} {auftragRequest.name_endkunde}
            <br />{auftragRequest.strasse_lieferadresse} {auftragRequest.hausnummer_lieferadresse}
            <br />{auftragRequest.postleitzahl_lieferadresse} {auftragRequest.stadt_lieferadresse}
            <br />{auftragRequest.land_lieferadresse}
            <br />Geokoordinate: {auftragRequest.lat} , {auftragRequest.lng}
          </div>
*/}
          <div className="form-group">
            Telefon Endkunde:
            <input className='form-control' name="telefon_lieferadresse" value={auftragRequest?.telefon_lieferadresse} onChange={handleChange} maxLength={100} />
            {errors.telefon_lieferadresse && <p className="text-red-500">{errors.telefon_lieferadresse}</p>}
          </div>

          <div className="form-group">
            Mobil 1 Endkunde:
            <input className='form-control' name="mobil1_lieferadresse" value={auftragRequest?.mobil1_lieferadresse} onChange={handleChange} maxLength={100} />
          </div>

          <div className="form-group">
            Mobil 2 Endkunde:
            <input className='form-control' name="mobil2_lieferadresse" value={auftragRequest?.mobil2_lieferadresse} onChange={handleChange} maxLength={100} />
          </div>

          <div className="form-group">
            Email Endkunde:
            <input className='form-control' name="email_lieferadresse" value={auftragRequest?.email_lieferadresse} onChange={handleChange} maxLength={100} />
          </div>

          <div className="form-group">
            ggf Ansprechpartner:
            <input className='form-control' name="ansprechpartner" value={auftragRequest?.ansprechpartner} onChange={handleChange} maxLength={100} />
          </div>

          <div className="form-group">
            Kontakt Ansprechpartner:
            <input className='form-control' name="kontakt_ansprechpartner" value={auftragRequest?.kontakt_ansprechpartner} onChange={handleChange} maxLength={100} />
          </div>

          <div className="form-group">
            E-Mail Ansprechpartner:
            <input className='form-control' name="email_ansprechpartner" value={auftragRequest?.email_ansprechpartner} onChange={handleChange} maxLength={100} />
          </div>

          <div className="form-group">
            Lieferant: <input name="lieferungLieferant" value={auftragRequest?.lieferungLieferant} onChange={handleChange} maxLength={255} />
            <span style={{ marginLeft: "10px" }}></span>
            Lieferung am (KW / Jahr):
            <input className='mb-3' name="lieferungKw" inputMode="numeric" maxLength={2} max={53} value={auftragRequest?.lieferungKw} onChange={handleChangeLieferungKw} />
            <span style={{ marginLeft: "10px", marginRight: "10px" }}>/</span>
            <input className='mb-3' name="lieferungJahr" inputMode="numeric" maxLength={4} value={auftragRequest?.lieferungJahr} onChange={handleChangeLieferungJahr} />
          </div>

          <div className="form-group">
            Hinweise zum Aufmaß und Messzeitpunkt:
            <textarea className='form-control' name="besonderheiten" rows={10} onChange={handleChangeTextarea} maxLength={512} value={auftragRequest?.besonderheiten}></textarea>
            <MaxInputAnzahlComponent max={512} aktuell={auftragRequest?.besonderheiten.length} />
          </div>

          <UploadContainer onFilesChange={handleFilesChange} />

          <p style={{ marginTop: "50px" }}></p>

          <div className="form-group">
            <input type="submit" className='btn btn-primary' value="Auftrag erteilen" onClick={speichern} />
          </div>

        </form>

      </div>

      <Footer />
    </div >
  );

}

